// test44
(44 && 0);
